import { TextField } from 'office-ui-fabric-react';
import * as React from 'react';
import { validation } from './JiraConnectionEdit';

export const BasicAuthControl = ({ login, apiToken, onChange }: { login?: string; apiToken?: string; onChange: (data: { login?: string; apiToken?: string; }) => void; }) => {
    return <>
        <TextField
            value={login}
            label="Login"
            placeholder="login"
            onChange={(e, _) => onChange({ login: _?.trim(), apiToken })}
            onGetErrorMessage={validation.login.getErrorMessage} />
        <TextField
            value={apiToken}
            type="password"
            label="API token for Jira Cloud or password for Jira Server"
            placeholder="API token or password"
            onChange={(e, _) => onChange({ login, apiToken: _ })}
            onGetErrorMessage={validation.apiToken.getErrorMessage} />
    </>;
};
